import Entity from "./entity";

/**
 * Represents a StripePlan or even a position that can place orders.
 *
 * Object representation for a StripePlan document from the database.
 */
class StripePlan extends Entity {
  constructor({ id, stripeId, name, description, prices } = {}) {
    super({ id: id });
    this.stripeId = stripeId;
    this.name = name;
    this.description = description;
    this.prices = prices;
  }

  /**
   * @returns A plain JS object containing the fields as they will be saved to the
   * database.
   */
  _toMap() {
    return {
      id: this.id,
      stripeId: this.stripeId,
      name: this.name,
      description: this.description,
      prices: this.prices
    };
  }

  /**
   * @param {*} snapData `Location` document data as a plain JS object
   * snapshot represented by this `Location`.
   *
   * @returns {Location} A new instance created from the provided map.
   */
  static _fromMap(snapData) {
    snapData.prices = snapData.prices ? snapData.prices.map(Price.fromMap) : [];
    return new StripePlan(snapData);
  }

  get _collectionName() {
    return `stripe_plans`;
  }

  get _entityName() {
    return "stripePlan";
  }
}

/**
 * Represents a `Price` that belongs to an `StripePlan` in a specific moment.
 */
class Price {
  constructor({ id, price, schedule } = {}) {
    this.id = id;
    this.price = price;
    this.schedule = schedule;
  }

  toMap() {
    return {
      id: this.id,
      price: this.price,
      schedule: this.schedule
    };
  }

  static fromMap(price) {
    return new Price(price);
  }
}

export default StripePlan;
